$(function(){
  // nordic_concept_slider ------------------------------
  const nordicConceptSwiper = new Swiper(".nordic_concept_slider .swiper", {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    loopAdditionalSlides: 1,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    allowTouchMove: false,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span><span class="' + totalClass + '"></span>';
      }
    },
    on: {
      slideChangeTransitionStart: function () {
      $('.bar span').css({
        'transition-duration': '0s',
        'transform': 'scaleX(0)'
      });
      },
      slideChangeTransitionEnd: function () {
        $('.bar span').css({
          'transition-duration': '4200ms',
          'transform': 'scaleX(1)'
        });
      },
    }
  });
  const nordicMvSwiper = new Swiper(".nordic_mv_img .swiper", {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    loopAdditionalSlides: 1,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    allowTouchMove: false
  });

  // nordic_related_swiper ------------------------------
  $('.nordic_related_swiper.swiper').each(function(){
    var featuredSwiper = new Swiper (this,{
        slidesPerView: 'auto',
        navigation: {
          nextEl: jQuery(this).find('.swiper-button-next-nordic').get(0),
          prevEl: jQuery(this).find('.swiper-button-prev-nordic').get(0),
        },
    });
  });

  // scroll anime ------------------------------
  $('.anime').each(function(){
    var elemTop = $(this).offset().top;
    var windowHeight = elemTop - $(window).height();
    if ($(window).scrollTop() > windowHeight){
      if(!$(this).hasClass('active')) {
        $(this).addClass('active');
      };
    };
  });
  $(window).scroll(function(){ 
    var scroll = $(window).scrollTop();
    $('.anime').each(function(){
      var elemTop = $(this).offset().top + 100;
      var windowHeight = $(window).height();
      if (scroll + windowHeight > elemTop){
        if(!$(this).hasClass('active')) {
          $(this).addClass('active');
        };
      };
    });
  });
});